import React from 'react';
import useWizardTree from '../../Hooks/useWizardTree';
import { WizardType } from '../../Enums/WizardType.enum';
import WizardItem from '../WizardItems/WizardItem';
// @ts-ignore
import styles from './Wizard.module.scss';
import Loading from '../../../BaseModule/Components/Loading';
import { useWizardContext } from '../../Services/WizardContext';
import { useEffectAsync } from '../../../../helpers';

export interface WizardScreenData {
	slideIndex?: number;
}

interface Props {
	wizardKey: string;
	type: WizardType;
}

const GetWizard: React.FC<Props> = ({ wizardKey, type }) => {
	const { activeScreen, setWizardScheme } = useWizardContext();

	const { getWizard } = useWizardTree({
		wizardKey,
		params: {},
	});

	useEffectAsync(async () => {
		const wizard = await getWizard();
		if (wizard) {
			setWizardScheme(wizard);
		}
	}, [wizardKey]);

	if (!activeScreen) {
		return (
			<div className={styles.loadingWrapper}>
				<Loading />
			</div>
		);
	}

	return (
		<div className={styles.wrapper}>
			<WizardItem item={activeScreen} type={type} />
		</div>
	);
};

export default GetWizard;
